// stores/unreadMessagesStore.js
import {defineStore} from 'pinia';
import {ref, computed, watch} from 'vue';
import {useAuthStore} from "@/store/authStore.js";

const KeyUnreadMessagesCount = "unreadMessagesCount"

export const useUnreadMessagesStore = defineStore('unreadMessagesStore', () => {
    const authStore = useAuthStore();
    const count = ref(0);

    // Инициализируем хранилище
    const init = () => {
        const savedCount = localStorage.getItem(`${KeyUnreadMessagesCount}_${authStore?.userId}`);
        count.value = savedCount ? Math.max(0, parseInt(savedCount)) : 0;
    };

    // Вызываем инициализацию при создании хранилища
    init();

    watch(count, (newCount) => {
        localStorage.setItem(`${KeyUnreadMessagesCount}_${authStore?.userId}`, newCount);
    });

    const increment = (value = 1) => {
        count.value += value;
    };

    const decrement = (value = 1) => {
        count.value = Math.max(0, count.value - value);
    };

    const reset = () => {
        count.value = 0;
    };

    const set = (value) => {
        count.value = value;
    };

    const hasUnread = computed(() => count.value > 0);

    return {
        count,
        hasUnread: computed(() => count.value > 0),
        increment,
        decrement,
        reset,
        set,
        init,
    };
});